import React from 'react';

const VARIANTS = {
  primary:   'bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 disabled:bg-primary-300 focus:ring-primary-200',
  secondary: 'bg-white text-neutral-800 border border-neutral-300 hover:bg-neutral-50 active:bg-neutral-100 disabled:bg-neutral-50 disabled:text-neutral-400 focus:ring-neutral-200',
  danger:    'bg-danger-600 text-white hover:bg-danger-700 active:bg-danger-700 disabled:bg-danger-300 focus:ring-danger-200',
  success:   'bg-success-600 text-white hover:bg-success-700 active:bg-success-700 disabled:bg-success-300 focus:ring-success-200',
  ghost:     'bg-transparent text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus:ring-neutral-200',
  link:      'bg-transparent text-primary-600 hover:text-primary-700 hover:underline px-1 py-0 focus:ring-0',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-sm rounded-md',
  md: 'px-4 py-2 text-sm rounded-md',
  lg: 'px-5 py-2.5 text-base rounded-lg',
};

const Spinner = ({ size = 'md' }) => (
  <svg
    className={`animate-spin ${size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'}`}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
  </svg>
);

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  fullWidth = false,
  leftIcon,
  rightIcon,
  className = '',
  ...rest
}) => {
  const variantCls = VARIANTS[variant] || VARIANTS.primary;
  const sizeCls = SIZES[size] || SIZES.md;
  const base = 'inline-flex items-center justify-center gap-2 font-medium transition-colors focus:outline-none focus:ring-4 disabled:cursor-not-allowed';
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`${base} ${variantCls} ${sizeCls} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...rest}
    >
      {loading ? <Spinner size={size} /> : leftIcon}
      <span>{children}</span>
      {!loading && rightIcon}
    </button>
  );
};

export default Button;
